import React from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  videoContainer: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "#00000031",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  iframe: {
    width: 560,
    height: 315,
  },
});

export const YTVideoModal = ({ videoId, setVideoId }) => {
  const classes = useStyles();
  const embedUrl = `https://www.youtube.com/embed/${videoId}`;

  return (
    <div onClick={() => setVideoId("")} className={classes.videoContainer}>
      <iframe
        className={classes.iframe}
        src={embedUrl}
        title="Embedded Video"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      ></iframe>
    </div>
  );
};
